import UiElement from '../../../shared/ui-element/ui-element';

class Switcher extends UiElement {
  switcherItemActiveClassName = 'switcher__toggler_active';

  switcherContentActiveClassName = 'switcher__content_active';

  uiCollections = {
    togglers: '[data-switcher-toggler]',
    contents: '[data-switcher-content]',
  };

  events = {
    'click @uiCollections.togglers': 'handleTabClick',
  };

  handleTabClick = (event) => {
    event.preventDefault();

    const togglerEl = event.currentTarget;

    if (togglerEl.classList.contains(this.switcherItemActiveClassName)) {
      return;
    }

    this.uiCollections.togglers.forEach((togglerEl) => {
      togglerEl.classList.remove(this.switcherItemActiveClassName);
    });
    togglerEl.classList.add(this.switcherItemActiveClassName);

    this.uiCollections.contents.forEach((contentEl) => {
      contentEl.classList.remove(this.switcherContentActiveClassName);

      if (contentEl.dataset.switcherContent === togglerEl.dataset.switcherToggler) {
        contentEl.classList.add(this.switcherContentActiveClassName);
      }
    });
  };
}

export default Switcher;
